import { Box, Container, Divider } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import Breadcrumbs from 'commons/Breadcrumbs';
import API from 'configs/API';
import Routes from 'utils/Route';

import ArtCatalogHeader from '../../commons/ArtCatalogHeader';
import FilterAlphabet from './components/FilterAlphabet';
import ListArtist from './components/ListArtist';
import useStyles from './styles';

const Artists = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams);

  const { data: artists = [] } = useQuery({
    queryKey: [API.AUTH.ARTIST.LIST, { ...params }],
  });

  const breadCrumbs = [
    {
      to: Routes.Home,
      text: t('home'),
    },
    {
      text: t('artists'),
      active: true,
    },
  ];

  return (
    <Box className={classes.wrapper}>
      <Container>
        <Box sx={{ pt: 3 }}>
          <Breadcrumbs items={breadCrumbs} />

          <Box sx={{ pt: 1 }}>
            <ArtCatalogHeader
              title={t('artist')}
              placeholder={t('search_artist_name')}
            />
            <FilterAlphabet />
            <Divider className={classes.dividerStyle} />
            <ListArtist artists={artists} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Artists;
